import { RootState } from '../store';
import { EsmeStateModel } from './esmeStateModel';
import { createSelector } from '@reduxjs/toolkit';
import { esmeAdapter } from './esmeReducer';
import { convertVersionableIdToString, VersionableId } from '../../types/versionableId';

const selectEsmeState = (state: RootState): EsmeStateModel => state.esme;
const selectCommitId = (state: RootState, commitId?: string) => commitId;
const selectVersionableId = (state: RootState, versionableId: VersionableId): string => (
  convertVersionableIdToString(versionableId)
);

export const selectAllEsme = createSelector(
  [selectEsmeState],
  esmeAdapter.getSelectors().selectAll,
);

export const selectAllEsmeByCommitId = createSelector(
  [selectAllEsme, selectCommitId],
  (esmeList, commitId) => {
    return commitId ? esmeList.filter(esme => esme.id.commitId === commitId) : [];
  },
);

export const selectEsmeByVersionableId = createSelector(
  [selectEsmeState, selectVersionableId],
  esmeAdapter.getSelectors().selectById,
);

export const selectIsLoadingEsme = createSelector(
  [selectEsmeState],
  state => state.loading,
);

export const selectErrorsForEsme = createSelector(
  selectEsmeState,
  state => state.errors,
);
